import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import { AppPaths } from "@p0security/shared/routes/constants";
import { Dropdown, Flex, Segmented, Spacing, Typography } from "@p0security/ui";
import { AssessmentSettingsSection } from "components/Assessment/styles";
import { AuthzButton } from "components/common/AuthzButton";
import { useCallback, useMemo, useState } from "react";

import { useNavigateWithEnv } from "../../../hooks/useNavigateWithEnv";
import { MonitorList } from "../../MonitorList";

const { Title } = Typography;

const ITEM_TITLE_LEVEL = 5;

const EditMonitorsSection: React.FC = () => {
  const navigateWithEnv = useNavigateWithEnv();
  const [showArchived, setShowArchived] = useState(false);
  const actionTypes = useMemo(() => {
    return showArchived
      ? ["edit", "unarchive"]
      : ["template", "edit", "archive"];
  }, [showArchived]);

  const handleArchiveToggle = useCallback((value: number | string) => {
    setShowArchived(value === "archived");
  }, []);

  const handleCreateMonitorFromScratch = useCallback(() => {
    const params = new URLSearchParams({
      createMonitor: "true",
    });
    navigateWithEnv(`${AppPaths.Inventory}?${params.toString()}`, {}, true);
  }, [navigateWithEnv]);

  const handleCreateMonitorFromTemplate = useCallback(() => {
    const params = new URLSearchParams({
      createMonitor: "true",
      templateMode: "true",
    });
    navigateWithEnv(`${AppPaths.Inventory}?${params.toString()}`, {}, true);
  }, [navigateWithEnv]);

  const createMenu = useMemo(
    () => ({
      items: [
        {
          key: "scratch",
          label: "Create from Scratch",
          onClick: handleCreateMonitorFromScratch,
        },
        {
          key: "template",
          label: "Create from Template",
          onClick: handleCreateMonitorFromTemplate,
        },
      ],
    }),
    [handleCreateMonitorFromScratch, handleCreateMonitorFromTemplate]
  );

  return (
    <>
      <Flex justify="space-between" align="center">
        <Spacing asChild m={0}>
          <Title level={ITEM_TITLE_LEVEL}>Monitors</Title>
        </Spacing>
        <Dropdown menu={createMenu} trigger={["click"]} placement="bottomRight">
          <AuthzButton
            roles={["owner", "iamOwner"]}
            type="primary"
            icon={<PlusOutlined />}
          >
            Create Monitor{" "}
            <Spacing asChild ml={4}>
              <DownOutlined />
            </Spacing>
          </AuthzButton>
        </Dropdown>
      </Flex>
      <Segmented
        options={[
          { label: "Active", value: "active" },
          { label: "Archived", value: "archived" },
        ]}
        onChange={handleArchiveToggle}
      />
      <MonitorList
        actionTypes={actionTypes}
        showFindings={false}
        showArchived={showArchived}
      />
    </>
  );
};

const EnvironmentMonitorPage: React.FC = () => (
  <Spacing mb={24}>
    <AssessmentSettingsSection>
      <EditMonitorsSection />
    </AssessmentSettingsSection>
  </Spacing>
);

export default EnvironmentMonitorPage;
